import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["border", "children", "fwdRef"];
import React, { forwardRef } from 'react';
import { buildVersionedClassNames } from '@op/opds.opux-utilities';
/**
 * _A header cell for a table._
 *
 * ***
 *
 * `TableHeaderCell` is used within the [`TableHeaderRow`](#/Lists%20%26%20Tables/TableHeaderRow)
 * or [`TableRow`](#/Lists%20%26%20Tables/TableRow) to display a table cell.
 * It renders `<th>` element.
 *
 * Additional props will be forwarded to the wrapping `<th>` element.
 */
export const TableHeaderCell = _ref => {
  let {
      border,
      children,
      fwdRef
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement("th", _extends({
    className: buildVersionedClassNames('ds-table-cell', {
      'ds-table-cell--border-right': border === 'right',
      'ds-table-cell--border-left': border === 'left'
    })
  }, props, {
    ref: fwdRef
  }), children);
};
const Fwd = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(TableHeaderCell, _extends({}, props, {
  fwdRef: ref
})));
Fwd.displayName = 'TableHeaderCell';
export default Fwd;